import { render, staticRenderFns } from "./KnowledgeIcon.vue?vue&type=template&id=1d0699e7"
import script from "./KnowledgeIcon.vue?vue&type=script&lang=js"
export * from "./KnowledgeIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports